import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, Users, TrendingUp } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center">
      {/* Background Gradient */}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-gradient-to-r from-[hsl(215,65%,14%)] via-[hsl(215,55%,22%)] to-[hsl(210,45%,30%)]"></div>
        {/* Bottom fade overlay to page background */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[hsl(210,20%,98%)]"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mt-28 md:mt-48">
        <div className="max-w-4xl mx-auto flex flex-col items-center">
          <h1 className="text-lg sm:text-2xl lg:text-3xl font-bold text-[#9ca3af] mb-6 leading-tight sm:whitespace-nowrap">
            Expert Property Consultancy and Management
          </h1>
          
          <p className="text-base sm:text-xl text-gray-100 mb-8 max-w-2xl leading-relaxed mx-auto px-2">
            PA Global delivers specialized guidance on private sector properties, social housing, and residential developments. Empowering agents with strategic insights and expert consultation.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12 justify-center items-center">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-[hsl(210,45%,45%)] hover:bg-white hover:text-[hsl(215,65%,22%)] text-white text-lg px-8 py-6 transition-all duration-300 shadow-lg uppercase"
            >
              Get Expert Advice
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button 
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[hsl(215,65%,22%)] text-lg px-8 py-6 transition-all duration-300 uppercase"
            >
              Our Services
            </Button>
          </div>

          {/* Stats/Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl">
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="bg-[hsl(210,45%,45%)] p-3 rounded-lg">
                <Shield className="text-white" size={24} />
              </div>
              <div>
                <p className="text-[hsl(215,50%,15%)] font-bold text-sm uppercase tracking-wide font-['Montserrat']">Trusted Expertise</p>
                <p className="text-gray-200 text-sm">Industry Leaders</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="bg-[hsl(210,45%,45%)] p-3 rounded-lg">
                <Users className="text-white" size={24} />
              </div>
              <div>
                <p className="text-[hsl(215,50%,15%)] font-bold text-sm uppercase tracking-wide font-['Montserrat']">Agent Focused</p>
                <p className="text-gray-200 text-sm">Tailored Solutions</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="bg-[hsl(210,45%,45%)] p-3 rounded-lg">
                <TrendingUp className="text-white" size={24} />
              </div>
              <div>
                <p className="text-[hsl(215,50%,15%)] font-bold text-sm uppercase tracking-wide font-['Montserrat']">Strategic Growth</p>
                <p className="text-gray-200 text-sm">Results Driven</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
